import { useEffect, usePersistedUserData } from 'src/hooks'
import { useValidatePhoneNumber } from 'src/react_query'
import { PhoneNumberInput } from 'src/graphql/generated/graphql'

const usePhoneNumberValidation = (
  phoneNumberInput: PhoneNumberInput | null,
) => {
  const { isLoading, mutateAsync, error, data, status } =
    useValidatePhoneNumber()
  const { account } = usePersistedUserData()

  const isCurrentUser =
    account && phoneNumberInput?.nationalNumber === account.phoneNumber
  const hasPhoneNumber = !!phoneNumberInput?.nationalNumber

  useEffect(() => {
    if (hasPhoneNumber && !isCurrentUser) {
      ;(async () => {
        await mutateAsync({
          phoneNumber: phoneNumberInput,
        })
      })()
    }
  }, [hasPhoneNumber, isCurrentUser, phoneNumberInput, mutateAsync])

  return {
    isLoading,
    hasPerformedValidation: status === 'success',
    isPhoneNumberTaken: status === 'success' ? !data?.isValid : false,
    error: status === 'error' ? error : undefined,
  }
}

export default usePhoneNumberValidation
